export default __webpack_public_path__ + "squarespace.3ed1350d.png";